import { OnInit, Component, ElementRef, ViewChild } from '@angular/core';
import { ReqResService } from '../../service/req-res.service';
import { PaginationInstance } from 'ngx-pagination';
import { PluginService } from '../../service/plugin.service';
import { Title } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { debounce } from 'lodash';
import { HttpClient } from '@angular/common/http';
declare var $: any;
declare var toastr: any;
declare var XLSX: any;
declare var html2pdf: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  loading = false;
  assemblyList: any[];
  sortReverse: boolean;
  sortType: string = 'default';
  searchAssembly: string = '';
  fileObjTemp: any = [];
  assemblyObj: any = { fileObj:[]};
  assemblyObjTemp: any = {};

  //del variables
  delId: number;
  delType: string;
  delCount: number;
  delBulkArray: any = [];
  delType2: string;
  assemblyCount: number = 0;
  maxCount: number = 0;
  sortdirection: string = 'D';
  userType: number = 0;
  public _pluginservice;
  constructor(private reqRes: ReqResService, private pluginservice: PluginService, private titleService: Title, private http: HttpClient) {
    this.titleService.setTitle('Home');
    this._pluginservice = this.pluginservice;
      this.getSearchData = debounce(this.getSearchData, 1000)
  };
  ngOnInit(): void {
    $('.modal-dialog').draggable({
      "handle": ".modal-header,.modal-footer"
    });
    $('.modal').on('hidden.bs.modal', function () {
      $('.modal-dialog').attr('style', 'inset: unset')
    });
    this.sortReverse = true;
    this.sortType = 'default';
    let json = {
      "Search": '',
      "Count": this.assemblyCount,
      "Direction": 'D',
      "SortType": this.sortType
    };
    this.getAssemblyList(JSON.stringify(json), 0);
    this._pluginservice.masterSelectedRefresh('assemblyBulk', []);
    this._pluginservice.checkedList = [];
    this.userType = JSON.parse(localStorage.getItem('userinfo'))[0].typeId;
  }

  searchInputOperation() {
    $("[data-toggle='tooltip']").tooltip('hide');
  }
  openFilter() {
    $(`#divSearchFilter`).removeClass("d-none")
    $(`#divSearchFilter`).addClass("d-inline-block")
    $(`#divSearchFilter`).animate({ right: '0px' }, "slow");
    $(`#btnSearchFilter`).hide();
    $(`#inputSearchFilter`).focus();
  }
  closeFilter() {
    $(`#divSearchFilter`).removeClass("d-inline-block")
    $(`#divSearchFilter`).addClass("d-none")
    $(`#btnSearchFilter`).show();
  }
  //================================================================
  changeStatus(param, id, status, param2): void {
    if (param2 == 'changeStatus') {
      status = status ? 1 : 0;
    }
    let assemblyObj: any = {};
    assemblyObj.param = param;
    assemblyObj.id = id;
    assemblyObj.status = status;
    this.reqRes.postData('/Global/ChangeStatus', assemblyObj).subscribe(data => {
      if (param == 'assembly' && param2 == 'delete') {
        let index = this.assemblyList.findIndex(item => item.id == id);
        this.assemblyList.splice(index, 1);
        toastr.success('Done!', '', { timeOut: 1000 });
      }
      else if (param == 'assembly' && param2 == 'changeStatus') {
      }
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error)
    })
  }
  sortData(type) {
    this.sortType = type;
    this.assemblyCount = 0;
    this.sortdirection = (this.sortReverse) ? 'A' : 'D';
    this.searchAssembly = (this.searchAssembly) ? this.searchAssembly : '';
    let json = {
      "Search": this.searchAssembly,
      "Count": this.assemblyCount,
      "Direction": this.sortdirection,
      "SortType": this.sortType
    };
    this.getAssemblyList(JSON.stringify(json), 0);
  }
  getSearchData(search) {
    this.searchAssembly = (search) ? search : '';
    this.assemblyCount = 0;
    this.sortType = (this.searchAssembly) ? 'scvalue' : 'default';
    let json = {
      "Search": this.searchAssembly,
      "Count": this.assemblyCount,
      "Direction": (this.searchAssembly) ? 'A' : 'D',
      "SortType": this.sortType
    };
    $("div[id^=threeNo] button").prop('disabled', false);
    this.getAssemblyListObservable(JSON.stringify(json), 0).subscribe(data => {

      this.assemblyList = data.assemblyData;
      this.maxCount = data.maxCount;
      if (this._pluginservice.checkedList.length == 1) {
        setTimeout(() => {
          $("#threeNo" + this.checkItemId + " button").prop('disabled', false);
          $("div[id^= 'threeNo'] button").prop('disabled', true);
        }, 500)
      } else if (this._pluginservice.checkedList.length > 1) {
        setTimeout(() => {
          $("div[id^= 'threeNo'] button").prop('disabled', true);
        }, 500)
      }
      this.loading = false;
    },
      error => { toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 }) },
      () => { //console.log("Completed")

      }
    )
  }
  getAssemblyListObservable(json, ope): Observable<any> {
    this.loading = true;
    let GridParametrs: any = {};
    GridParametrs.type = 'assembly';
    GridParametrs.json = json;
    return this.reqRes.postData('/Assembly/GetAssemblyListData', GridParametrs).pipe(
      debounceTime(1000),
      distinctUntilChanged()
    )
  }
  getAssemblyList(json, ope) {
    this.loading = true;
    let GridParametrs: any = {};
    GridParametrs.type = 'assembly';
    GridParametrs.json = json;
    this.reqRes.postData('/Assembly/GetAssemblyListData', GridParametrs).subscribe(data => {
      this.loading = false;
      this.assemblyList = (ope == 0) ? this.assemblyList = data.assemblyData : this.assemblyList.concat(data.assemblyData);
   
      this.maxCount = data.maxCount;
      if (this._pluginservice.checkedList.length == 1) {
        setTimeout(() => {
          $("div[id^= 'threeNo'] button").prop('disabled', true);
          $("#threeNo" + this.checkItemId + " button").prop('disabled', false);
        }, 500)
      } else if (this._pluginservice.checkedList.length > 1) {
        setTimeout(() => {
          $("div[id^= 'threeNo'] button").prop('disabled', true);
        }, 500)
      }
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error); this.loading = false;
      })
  }
  checkItemId: number = 0;
  getCheckedId(id) {
    this.checkItemId = id;
  }

  onScrollData(event: any) {
    if (event.target.offsetHeight + event.target.scrollTop + 1 >= event.target.scrollHeight && this.assemblyCount <= this.maxCount) {
      this.assemblyCount = this.assemblyCount + 5000;
      let json = {
        "Search": this.searchAssembly,
        "Count": this.assemblyCount,
        "Direction": this.sortdirection,
        "SortType": this.sortType
      };
      this.getAssemblyList(JSON.stringify(json), 1);
      //$("div[id^=threeNo] button").prop('disabled', false);
      //this._pluginservice.UnCheckAll(this.status);
    }
  }

  modalDelete(delId, delType, delType2, bulkArray) {
    this.delId = delId;
    this.delType = delType;
    this.delType2 = delType2;
    this.delBulkArray = bulkArray;
    if (bulkArray.length == 0) {
      this.delCount = 1;
    } else {
      this.delCount = this._pluginservice.checkedList.length;
    }
    $('#modalDelete').modal('show');
  }

  deleteItem(id, type, type2, array) {
    $("div[id^=threeNo] button").prop('disabled', false);
    $('#modalDelete').modal('hide');
    if (array.length == 0) {
      this.changeStatus(type, id, -1, type2);
    } else {
      let ids = this._pluginservice.bulkActions(array[0]);
      ids.forEach((id) => {
        let index = this.assemblyList.findIndex(item => item.id == id);
        this.assemblyList.splice(index, 1);
      });
      var $this = this;
      this.sortReverse = true;
      this.sortType = 'default';
      let json = {
        "Search": '',
        "Count": this.assemblyCount,
        "Direction": 'D',
        "SortType": this.sortType
      };
      setTimeout(function () { $this.getAssemblyList(JSON.stringify(json), 0); }, 200)
      this._pluginservice.checkedList = [];
    }
    this._pluginservice.masterSelectedRefresh(`assemblyBulk`);
  }

  modalDeleteClose() {
    $('#modalDelete').modal('hide');
  }

  //#region File
  @ViewChild('myfileInput')
  myfileInputVariable: ElementRef;
  filesData: any = {};
  filesDataTemp: any = {};
  fileId: number;
  fileObj: any = {};
  drawingInstance: any;
  fileList: FileList = null;
  fileListOpe = false;
  fileType: number = 1;
  readonly maxUploadFileSize = 50000000;
  files(id, type) {
    this.fileType = type;
    this.clearSelectedFile();
    if (this.assemblyObj.fileObj) { this.fileObjTemp = JSON.parse(JSON.stringify(this.assemblyObj.fileObj)); } else { this.fileObjTemp = [] }
    $("#modal_files").modal("show");
    this.fileId = id;
  }



  uploadedFile: any;
  spinner: boolean = false;
  clearSelectedFile() {
    this.uploadedFile = null;
    this.fileList = null;
    this.fileListOpe = false;
    this.fileDesc = "";
    if (this.myfileInputVariable) {
      this.myfileInputVariable.nativeElement.value = "";
    }
  }
  resetPendingUploads() {
    this.newFileObj = [];
    this.fileObjTemp = [];
    this.clearSelectedFile();
  }
  handleFileInput(event, files: FileList) {
    if (!files || files.length === 0) {
      this.clearSelectedFile();
      return;
    }

    const selectedFile = files[0];
    if (!selectedFile || selectedFile.size === 0) {
      this.clearSelectedFile();
      toastr.warning("Empty file cannot be uploaded.", '', { timeOut: 1500 });
      return;
    }

    const duplicateFile = this.fileObjTemp.some(item =>
      item.ope != -1 &&
      item._type == this.fileType &&
      item.name == selectedFile.name &&
      item.size == selectedFile.size
    );

    if (duplicateFile) {
      this.clearSelectedFile();
      toastr.warning("This file is already added.", '', { timeOut: 1500 });
      return;
    }

    this.uploadedFile = selectedFile;
    if (selectedFile.size > this.maxUploadFileSize) {
      this.clearSelectedFile();
      this.fileListOpe = true;
      toastr.warning("File is too large. Maximum allowed size is 50 MB.", '', { timeOut: 2000 });
    }
    else {
      this.fileListOpe = false;
      this.fileList = files;
    }
  }
  fileDesc: string = "";
  newFileObj: any = [];
  


  addFile(desc,type) {
    if (!this.uploadedFile) {
      toastr.warning("Please choose a file first.", '', { timeOut: 1500 });
      return;
    }
    this.newFileObj.push({ _file: this.uploadedFile, _desc: desc, _type: type });
    if (!this.assemblyObj.fileObj) {
      this.assemblyObj.fileObj = [];
    }
    this.fileObjTemp.push({ id: 0, name: this.uploadedFile.name, size: this.uploadedFile.size, _desc: desc, _url: '', _date: '', ope: 1, _type: type });
    this.clearSelectedFile();
  }
  deleteFile(i) {
    if (!this.fileObjTemp[i]) return;
    this.fileObjTemp[i].ope = -1;
    let index = this.newFileObj.findIndex(item =>
      item._file &&
      item._file.name == this.fileObjTemp[i].name &&
      item._file.size == this.fileObjTemp[i].size &&
      item._type == this.fileObjTemp[i]._type
    );
    if (index >= 0) {
      this.newFileObj.splice(index, 1);
    }
  }

  downloadFile(url: string, fileName: string) {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;          // ***ƏSAS HİSSƏ***
    document.body.appendChild(a);   // DOM-a əlavə et
    a.click();                      // kliklə
    document.body.removeChild(a);   // DOM-dan sil
    URL.revokeObjectURL(url);       // URL-i təmizlə
  }

  okFile() {
    if (this.uploadedFile) {
      toastr.warning("Click Add before OK to include the selected file.", '', { timeOut: 2000 });
      return;
    }
    this.assemblyObj.fileObj = [];
    this.fileObjTemp.forEach((value, key) => {
        this.assemblyObj.fileObj.push({ id: value.id, name: value.name, size: value.size, _desc: value._desc, _url: value._url, _date: value._date, ope: value.ope, _type:value._type })
    })
    this.assemblyObj.fileCount = 0;
    this.assemblyObj.wfileCount = 0;
    console.log(this.assemblyObj.fileObj)
    this.assemblyObj.fileObj.forEach((value, key) => {
      if (value.ope != -1) {
        if (value._type == 1) {
          this.assemblyObj.fileCount = this.assemblyObj.fileCount + 1;
        }
        else if (value._type == 2) {
          this.assemblyObj.wfileCount = this.assemblyObj.wfileCount + 1;
        }
      }
    });
   
    $("#modal_files").modal("hide");

  //  this.spinner = true;
  //  $('#btnFileSave').attr("disabled", "disabled");
  //  if (this.projectFileId == 0) {
  //    let Files: any = [];
  //    let formData = new FormData();
  //    for (let j = 0; j < this.fileList.length; j++) {
  //      formData.append('Files', this.fileList.item(j), this.fileList.item(j).name);
  //    }
  //    formData.append('type', 'Project');
  //    this.reqRes.postData('/Global/UploadFile', formData).subscribe(data => {
  //      Files = data;
  //      let obj: any = {};
  //      obj.id = this.projectFileId;
  //      obj.projectId = this.projectId;
  //      obj.desc = this.projectFileObj.desc;
  //      obj.fileObj = Files;
  //      this.reqRes.postData('/Project/ProjectFileOperation', obj).subscribe(data => {
  //        setTimeout(function () {
  //          $('#btnFileSave').removeAttr("disabled");
  //        }, 1000)
  //        this.projectfilesData.fileObj = data.fileObj;
  //        const cloneOfObject = JSON.parse(JSON.stringify(this.projectfilesData.fileObj));
  //        this.projectfilesDataTemp.fileObj = cloneOfObject;
  //        this.myfileInputVariable.nativeElement.value = "";
  //        this.fileList = null;
  //        t
  //        $("#modal_files").modal("hide");
  //        $('#collapseFiles').addClass("show");
  //        this.spinner = false;
  //        toastr.success('Done!', '', { timeOut: 1000 });
  //      }, error => {
  //        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
  //        console.log(error);
  //      })
  //    }, error => {
  //      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
  //      console.log(error);
  //    })
  //  }
  //  else {
  //    let obj: any = {};
  //    obj.id = this.fileId;
  //    obj.assemblyId = this.assemblyId;
  //    obj.desc = this.projectFileObj.desc;
  //    this.reqRes.postData('/Project/ProjectFileOperation', obj).subscribe(data => {
  //      setTimeout(function () {
  //        $('#btnFileSave').removeAttr("disabled");
  //      }, 1000)
  //      this.filesData.fileObj = data.fileObj;
  //      const cloneOfObject = JSON.parse(JSON.stringify(this.filesData.fileObj));
  //      this.filesData.fileObj = cloneOfObject;
  //      $("#modal_files").modal("hide");
  //      $('#collapseFiles').addClass("show");
  //      toastr.success('Done!', '', { timeOut: 1000 });
  //    }, error => {
  //      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
  //      console.log(error);
  //    })
  //  }
  }

  /*fileDelId: number;*/
 modalFileDelete(delId) {
  //  this.fileDelId = delId;
  //  $('#modalFileDelete').modal('show');
  }
  fileDelete(id) {
  //  let index = this.filesData.fileObj.findIndex(item => item.id == id);
  //  let fileDelObj: any = {};
  //  fileDelObj.id = this.filesData.fileObj[index].id;
  //  fileDelObj.url = this.filesData.fileObj[index].serverUrl;
  //  this.reqRes.postData('/Global/FileDelete', fileDelObj).subscribe(data => {
  //    this.reqRes.getData('/Project/GetProjectReturnFiles/' + this.projectId).subscribe(data => {
  //      this.filesData.fileObj = data.fileObj;
  //      this.setMenuCount.emit('{"key":"file", "cnt":-1}');
  //      const cloneOfObject = JSON.parse(JSON.stringify(this.filesData.fileObj));
  //      this.projectfilesDataTemp.fileObj = cloneOfObject;
  //      $('#modalFileDelete').modal('hide');
  //      $("[data-toggle='tooltip']").tooltip('hide');
  //      toastr.success('Done!', '', { timeOut: 1000 });
  //    },
  //      error => {
  //        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
  //        console.log(error);
  //      })
  //  }, error => {
  //    toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
  //    console.log(error)
  //  });
}
  //#endregion


  //================================================================
  //#region Modal Status


  newInspection() {
    this.assemblyObj.inspectionId = 0;
    this.assemblyObj.typeId = 0;
    this.assemblyObj._date = this.formatToYYYYMMDD(new Date());
    this.assemblyObj.inspectorId = 0;
    this.assemblyObj.inspectorCode = '';
    this.assemblyObj.conditionId = 0;
    this.assemblyObj.conditionCode = '';
    this.assemblyObj.reasonId1 = 0; this.assemblyObj.reasonCode1 = ''; this.assemblyObj.reasonName1 = '';
    this.assemblyObj.reasonId2 = 0; this.assemblyObj.reasonCode2 = ''; this.assemblyObj.reasonName2 = '';
    this.assemblyObj.reasonId3 = 0; this.assemblyObj.reasonCode3 = ''; this.assemblyObj.reasonName3 = '';
    this.assemblyObj.reasonId4 = 0; this.assemblyObj.reasonCode4 = ''; this.assemblyObj.reasonName4 = '';
    this.assemblyObj.reasonId5 = 0; this.assemblyObj.reasonCode5 = ''; this.assemblyObj.reasonName5 = '';
    this.assemblyObj.recommendation = '';
    this.assemblyObj.comment = '';
    this.assemblyObj.scrappedDate = '';
    this.assemblyObj.authBy = '';
  }




  modalTitleAssembly: string = '';
  reinspectionOpe: boolean = false;
  editAssembly(id, ope, status) {
    this.resetPendingUploads();
    if (ope == 'edit') { this.reinspectionOpe = false; this.modalTitleAssembly = 'Edit Assembly'; $('#btn_save').removeAttr('style'); $('#btn_save_next').removeAttr('style'); $('#assembyBody').removeAttr('style'); $('#btn_NEXT').prop('disabled', false); $('#btn_PREV').prop('disabled', false); $('#btn_save_next').prop('disabled', false);}
    else if (ope == 'new') { this.reinspectionOpe = false; this.modalTitleAssembly = 'New Assembly'; $('#btn_save').removeAttr('style'); $('#btn_save_next').removeAttr('style'); $('#btn_save_next').attr('style', 'display:none');  $('#assembyBody').removeAttr('style'); }
    else if (ope == 'view') { this.reinspectionOpe = false; this.modalTitleAssembly = 'View Assembly'; $('#btn_save').attr('style', 'display:none'); $('#btn_save_next').attr('style', 'display:none'); $('#assembyBody').attr('style', 'pointer-events:none'); $('#btn_NEXT').prop('disabled', false); $('#btn_PREV').prop('disabled', false); }
    else if (ope == 'duplicate') { this.reinspectionOpe = false; this.modalTitleAssembly = 'Duplicate Assembly'; $('#btn_save').removeAttr('style'); $('#btn_save_next').removeAttr('style'); $('#btn_save_next').attr('style', 'display:none');  $('#assembyBody').removeAttr('style');}
    else if (ope == 'reinspection') { this.reinspectionOpe = true; this.modalTitleAssembly = 'Re-inspection Assembly'; $('#btn_save').removeAttr('style'); $('#btn_save_next').removeAttr('style'); $('#assembyBody').removeAttr('style'); $('#btn_NEXT').prop('disabled', false); $('#btn_PREV').prop('disabled', false); $('#btn_save_next').prop('disabled', false); }
    $('#assemblyModal').modal('show');
   this.reqRes.getData('/Assembly/GetAssemblyDetail/' + id).subscribe(data => {
     this.assemblyObj = data;
     if (ope == 'duplicate') {
       this.fileObjTemp = [];
       this.assemblyObj.fileCount = 0;
       this.assemblyObj.wfileCount = 0;
       this.fileObj = [];

       this.assemblyObj.id = 0;

       // Yeni inspection məlumatları yaransın
       this.newInspection();

       // Duplicate-də yeni Loc Tag boş olsun
       this.assemblyObj.locTagNo = '';

       // Yeni serial backend-dən gəlirsə onu yazırıq
       this.assemblyObj.serialNo = data.newSerialNo;

       // Spec Code / speccodeModal məlumatları saxlanılır:
       // specCode
       // specCodeDesc
       // hoseType
       // boreSize
       // boreLength
       // orientation
       // methodId
       // minTemp
       // maxTemp
       // maxWP
       // speccodeObj

       if (this.assemblyObj.speccodeObj && typeof this.assemblyObj.speccodeObj === 'string') {
         this.assemblyObj.speccodeObj = JSON.parse(this.assemblyObj.speccodeObj);
       }
     }
     else if (ope == 'reinspection') {
       this.newInspection();
     }
     //Clone Project Type Modal Information to Temp Obj //
     const cloneOfObject = JSON.parse(JSON.stringify(this.assemblyObj));
     this.assemblyObjTemp = cloneOfObject;
     /////////////////////////////////////////////
     $('#assemblyModal').modal('show');
   },
     error => {
       toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
       console.log(error);
     })
  }
  getSpeccodeInfo(code) {
    this.reqRes.getData('/Assembly/GetSpecodeInfo/' + code+'').subscribe(data => {
      this.assemblyObj.specCodeDesc = data.specDesc;


     
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })

  }


  sendHolcim() {
    this.reqRes.getData('/Assembly/holcimsend/').subscribe(data => {
     
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }

  deleteHolcim() {
    this.reqRes.deleteData('/Assembly/holcimdelete/').subscribe(
      data => {
        toastr.success("Uğurla silindi", '', { timeOut: 1000 });
      },
      error => {
        toastr.error("Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      }
    );
  }
  next(id,type) {
    if (this.newFileObj.length > 0 || this.uploadedFile) {
      toastr.warning("Please save or remove selected files before moving to another record.", '', { timeOut: 2500 });
      return;
    }
    this.reqRes.getData('/Assembly/GetAssemblyNexPrevId/' + id+'/'+type).subscribe(data => {
      if (data) {
        this.editAssembly(data, 'EDIT',0);
        $('#btn_NEXT').prop('disabled', false);
        $('#btn_PREV').prop('disabled', false);
        $('#btn_save_next').prop('disabled', false);
      }
      else {
        $('#btn_' + type).prop('disabled', true);
        $('#btn_save_next').prop('disabled', true);
      }
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
  controlReason(type) {
    let _obj:any = {};
     _obj = this.assemblyObj;
         if (type == 'reason1' && (_obj.reasonCode1 == _obj.reasonCode2 || _obj.reasonCode1 == _obj.reasonCode3 || _obj.reasonCode1 == _obj.reasonCode4 || _obj.reasonCode1 == _obj.reasonCode5)) { this.assemblyObj.reasonName1 = ''; this.assemblyObj.reasonId1 = 0; this.assemblyObj.reasonCode1 ='';  }
    else if (type == 'reason2' && (_obj.reasonCode2 == _obj.reasonCode1 || _obj.reasonCode2 == _obj.reasonCode3 || _obj.reasonCode2 == _obj.reasonCode4 || _obj.reasonCode2 == _obj.reasonCode5)) { this.assemblyObj.reasonName2 = ''; this.assemblyObj.reasonId2 = 0; this.assemblyObj.reasonCode2 = ''; }
    else if (type == 'reason3' && (_obj.reasonCode3 == _obj.reasonCode1 || _obj.reasonCode3 == _obj.reasonCode2 || _obj.reasonCode3 == _obj.reasonCode4 || _obj.reasonCode3 == _obj.reasonCode5)) { this.assemblyObj.reasonName3 = ''; this.assemblyObj.reasonId3 = 0; this.assemblyObj.reasonCode3 = ''; }
    else if (type == 'reason4' && (_obj.reasonCode4 == _obj.reasonCode1 || _obj.reasonCode4 == _obj.reasonCode2 || _obj.reasonCode4 == _obj.reasonCode3 || _obj.reasonCode4 == _obj.reasonCode5)) { this.assemblyObj.reasonName4 = ''; this.assemblyObj.reasonId4 = 0; this.assemblyObj.reasonCode4 = ''; }
    else if (type == 'reason5' && (_obj.reasonCode5 == _obj.reasonCode1 || _obj.reasonCode5 == _obj.reasonCode2 || _obj.reasonCode5 == _obj.reasonCode3 || _obj.reasonCode5 == _obj.reasonCode4)) { this.assemblyObj.reasonName5 = ''; this.assemblyObj.reasonId5 = 0; this.assemblyObj.reasonCode5 = ''; }
  }
  controlBReason(type) {
    let _obj: any = {};
    _obj = this.batchInspectionObj;
         if (type == 'breason1' && (_obj.reasonCode1 == _obj.reasonCode2 || _obj.reasonCode1 == _obj.reasonCode3 || _obj.reasonCode1 == _obj.reasonCode4 || _obj.reasonCode1 == _obj.reasonCode5)) { this.batchInspectionObj.reasonName1 = ''; this.batchInspectionObj.reasonId1 = 0; this.batchInspectionObj.reasonCode1 = ''; }
    else if (type == 'breason2' && (_obj.reasonCode2 == _obj.reasonCode1 || _obj.reasonCode2 == _obj.reasonCode3 || _obj.reasonCode2 == _obj.reasonCode4 || _obj.reasonCode2 == _obj.reasonCode5)) { this.batchInspectionObj.reasonName2 = ''; this.batchInspectionObj.reasonId2 = 0; this.batchInspectionObj.reasonCode2 = ''; }
    else if (type == 'breason3' && (_obj.reasonCode3 == _obj.reasonCode1 || _obj.reasonCode3 == _obj.reasonCode2 || _obj.reasonCode3 == _obj.reasonCode4 || _obj.reasonCode3 == _obj.reasonCode5)) { this.batchInspectionObj.reasonName3 = ''; this.batchInspectionObj.reasonId3 = 0; this.batchInspectionObj.reasonCode3 = ''; }
    else if (type == 'breason4' && (_obj.reasonCode4 == _obj.reasonCode1 || _obj.reasonCode4 == _obj.reasonCode2 || _obj.reasonCode4 == _obj.reasonCode3 || _obj.reasonCode4 == _obj.reasonCode5)) { this.batchInspectionObj.reasonName4 = ''; this.batchInspectionObj.reasonId4 = 0; this.batchInspectionObj.reasonCode4 = ''; }
    else if (type == 'breason5' && (_obj.reasonCode5 == _obj.reasonCode1 || _obj.reasonCode5 == _obj.reasonCode2 || _obj.reasonCode5 == _obj.reasonCode3 || _obj.reasonCode5 == _obj.reasonCode4)) { this.batchInspectionObj.reasonName5 = ''; this.batchInspectionObj.reasonId5 = 0; this.batchInspectionObj.reasonCode5 = ''; }
  }
  controlByCode(data,type) {
    if (type == 'company') { this.assemblyObj.companyName = data.name; this.assemblyObj.companyId = data.id; }
    else if (type == 'asset') { this.assemblyObj.assetName = data.name; this.assemblyObj.assetId = data.id; this.assemblyObj.refCode = data.refCode; this.getAssemblyDataByCode(data.refCode, 'ref') }
    else if (type == 'deck') { this.assemblyObj.deckName = data.name; this.assemblyObj.deckId = data.id; }
    else if (type == 'module') { this.assemblyObj.moduleName = data.name; this.assemblyObj.moduleId = data.id; }
    else if (type == 'ep') { this.assemblyObj.epName = data.name; this.assemblyObj.epId = data.id; }
    else if (type == 'media') { this.assemblyObj.mediaName = data.name; this.assemblyObj.mediaId = data.id; }
    else if (type == 'service') { this.assemblyObj.serviceId = data.id; }
    else if (type == 'custAttribute') { this.assemblyObj.custAttributeName = data.name; this.assemblyObj.custAttributeId = data.id; this.assemblyObj.inspFreq = data.inspFreq; this.changeDateByMonth(this.assemblyObj.inspFreq, 'inspFreq'); this.assemblyObj.replFreq = data.replFreq; this.changeDateByMonth(this.assemblyObj.replFreq, 'replFreq'); }
    else if (type == 'consequence') { this.assemblyObj.consequenceId = data.id; }
    else if (type == 'probability') { this.assemblyObj.probabilityId = data.id; }
    else if (type == 'supplier') { this.assemblyObj.supplierName = data.name; this.assemblyObj.supplierId = data.id; }
    else if (type == 'ref') { this.assemblyObj.refName = data.name; this.assemblyObj.refId = data.id; }
    else if (type == 'bref') { this.batchInspectionObj.refName = data.name; this.batchInspectionObj.refId = data.id; }



    else if (type == 'inspector') { this.assemblyObj.inspectorId = data.id; }
    else if (type == 'binspector') { this.batchInspectionObj.inspectorId = data.id; }
    else if (type == 'condition') { this.assemblyObj.conditionId = data.id; }
    else if (type == 'bcondition') { this.batchInspectionObj.conditionId = data.id; }

    else if (type == 'reason1') {this.assemblyObj.reasonName1 = data.name; this.assemblyObj.reasonId1 = data.id; this.controlReason(type); }
    else if (type == 'reason2') {this.assemblyObj.reasonName2 = data.name; this.assemblyObj.reasonId2 = data.id; this.controlReason(type); }
    else if (type == 'reason3') {this.assemblyObj.reasonName3 = data.name; this.assemblyObj.reasonId3 = data.id; this.controlReason(type); }
    else if (type == 'reason4') {this.assemblyObj.reasonName4 = data.name; this.assemblyObj.reasonId4 = data.id; this.controlReason(type); }
    else if (type == 'reason5') { this.assemblyObj.reasonName5 = data.name; this.assemblyObj.reasonId5 = data.id; this.controlReason(type); }

    else if (type == 'breason1') { this.batchInspectionObj.reasonName1 = data.name; this.batchInspectionObj.reasonId1 = data.id; this.controlBReason(type); }
    else if (type == 'breason2') { this.batchInspectionObj.reasonName2 = data.name; this.batchInspectionObj.reasonId2 = data.id; this.controlBReason(type); }
    else if (type == 'breason3') { this.batchInspectionObj.reasonName3 = data.name; this.batchInspectionObj.reasonId3 = data.id; this.controlBReason(type); }
    else if (type == 'breason4') { this.batchInspectionObj.reasonName4 = data.name; this.batchInspectionObj.reasonId4 = data.id; this.controlBReason(type); }
    else if (type == 'breason5') { this.batchInspectionObj.reasonName5 = data.name; this.batchInspectionObj.reasonId5 = data.id; this.controlBReason(type); }


    else if (type == 'hose') { this.speccodeObjClone.hoseId = data.id; }
    else if (type == 'bore') { this.speccodeObjClone.boreId = data.id; }

    else if (type == 'endStyle1') { this.speccodeObjClone.endStyleId1 = data.id; }
    else if (type == 'endStyle2') { this.speccodeObjClone.endStyleId2 = data.id; }
    else if (type == 'thread1') { this.speccodeObjClone.threadSizeId1 = data.id; }
    else if (type == 'thread2') { this.speccodeObjClone.threadSizeId2 = data.id; }
    else if (type == 'insert1') { this.speccodeObjClone.insertTypeId1 = data.id; }
    else if (type == 'insert2') { this.speccodeObjClone.insertTypeId2 = data.id; }
    else if (type == 'retention1') { this.speccodeObjClone.retentionTypeId1 = data.id; }
    else if (type == 'retention2') { this.speccodeObjClone.retentionTypeId2 = data.id; }


    this.syncSelect2ByType(type);
  }


  syncSelect2ByType(type: string) {
    const map: any = {
      media: ['#slc_media', this.assemblyObj.mediaId],
      service: ['#slc_service', this.assemblyObj.serviceId],
      custAttribute: ['#slc_custAttribute', this.assemblyObj.custAttributeId],
      consequence: ['#slc_consequence', this.assemblyObj.consequenceId],
      probability: ['#slc_probability', this.assemblyObj.probabilityId],
      supplier: ['#slc_supplier', this.assemblyObj.supplierId],
      inspector: ['#slc_inspector', this.assemblyObj.inspectorId],
      condition: ['#slc_condition', this.assemblyObj.conditionId],

      reason1: ['#slc_reason1', this.assemblyObj.reasonId1],
      reason2: ['#slc_reason2', this.assemblyObj.reasonId2],
      reason3: ['#slc_reason3', this.assemblyObj.reasonId3],
      reason4: ['#slc_reason4', this.assemblyObj.reasonId4],
      reason5: ['#slc_reason5', this.assemblyObj.reasonId5],

      breason1: ['#slc_breason1', this.batchInspectionObj?.reasonId1],
      breason2: ['#slc_breason2', this.batchInspectionObj?.reasonId2],
      breason3: ['#slc_breason3', this.batchInspectionObj?.reasonId3],
      breason4: ['#slc_breason4', this.batchInspectionObj?.reasonId4],
      breason5: ['#slc_breason5', this.batchInspectionObj?.reasonId5],

      hose: ['#slc_scHose', this.speccodeObjClone.hoseId],
      bore: ['#slc_scBore', this.speccodeObjClone.boreId],
      endStyle1: ['#slc_scEndStyle1', this.speccodeObjClone.endStyleId1],
      thread1: ['#slc_scThreadSize1', this.speccodeObjClone.threadSizeId1],
      insert1: ['#slc_scInsertType1', this.speccodeObjClone.insertTypeId1],
      retention1: ['#slc_scRetentionType1', this.speccodeObjClone.retentionTypeId1],
      endStyle2: ['#slc_scEndStyle2', this.speccodeObjClone.endStyleId2],
      thread2: ['#slc_scThreadSize2', this.speccodeObjClone.threadSizeId2],
      insert2: ['#slc_scInsertType2', this.speccodeObjClone.insertTypeId2],
      retention2: ['#slc_scRetentionType2', this.speccodeObjClone.retentionTypeId2]
    };

    if (!map[type]) return;

    setTimeout(() => {
      const selector = map[type][0];
      const value = map[type][1];

      if ($(selector).length) {
        $(selector).val(value).trigger('change.select2');
      }
    }, 100);
  }







  codeById(id, type) {
    if (type == 'media') {
      let i = this.assemblyObj.mediaObj.findIndex(item => item.id == id);
      this.assemblyObj.mediaCode = this.assemblyObj.mediaObj[i].code;
    }
    else if (type == 'service') {
      let i = this.assemblyObj.serviceObj.findIndex(item => item.id == id);
      this.assemblyObj.serviceCode = this.assemblyObj.serviceObj[i].code;
    }
    else if (type == 'custAttribute') {
      let i = this.assemblyObj.custAttributeObj.findIndex(item => item.id == id);
      this.assemblyObj.custAttributeCode = this.assemblyObj.custAttributeObj[i].code;
      this.getAssemblyDataByCode(this.assemblyObj.custAttributeCode, 'custAttribute')
    }
    else if (type == 'consequence') {
      let i = this.assemblyObj.consequenceObj.findIndex(item => item.id == id);
      this.assemblyObj.consequenceCode = this.assemblyObj.consequenceObj[i].code;
    }
    else if (type == 'probability') {
      let i = this.assemblyObj.probabilityObj.findIndex(item => item.id == id);
      this.assemblyObj.probabilityCode = this.assemblyObj.probabilityObj[i].code;
    }
    else if (type == 'supplier') {
      let i = this.assemblyObj.supplierObj.findIndex(item => item.id == id);
      this.assemblyObj.supplierCode = this.assemblyObj.supplierObj[i].code;
    }
    else if (type == 'supplier') {
      let i = this.assemblyObj.supplierObj.findIndex(item => item.id == id);
      this.assemblyObj.supplierCode = this.assemblyObj.supplierObj[i].code;
    }
    else if (type == 'inspector') {
      let i = this.assemblyObj.inspectorObj.findIndex(item => item.id == id);
      this.assemblyObj.inspectorCode = this.assemblyObj.inspectorObj[i].code;
    }
    else if (type == 'binspector') {
      let i = this.batchInspectionObj.inspectorObj.findIndex(item => item.id == id);
      this.batchInspectionObj.inspectorCode = this.batchInspectionObj.inspectorObj[i].code;
    }
    else if (type == 'condition') {
      let i = this.assemblyObj.conditionObj.findIndex(item => item.id == id);
      this.assemblyObj.conditionCode = this.assemblyObj.conditionObj[i].code;
    }
    else if (type == 'bcondition') {
      let i = this.batchInspectionObj.conditionObj.findIndex(item => item.id == id);
      this.batchInspectionObj.conditionCode = this.batchInspectionObj.conditionObj[i].code;
    }
    else if (type == 'reason1') {
      let i = this.assemblyObj.reasonObj.findIndex(item => item.id == id);
      this.assemblyObj.reasonCode1 = this.assemblyObj.reasonObj[i].code;
      this.controlReason(type);
    }
    else if (type == 'reason2') {
      let i = this.assemblyObj.reasonObj.findIndex(item => item.id == id);
      this.assemblyObj.reasonCode2 = this.assemblyObj.reasonObj[i].code;
      this.controlReason(type);
    }
    else if (type == 'reason3') {
      let i = this.assemblyObj.reasonObj.findIndex(item => item.id == id);
      this.assemblyObj.reasonCode3 = this.assemblyObj.reasonObj[i].code;
      this.controlReason(type);
    }
    else if (type == 'reason4') {
      let i = this.assemblyObj.reasonObj.findIndex(item => item.id == id);
      this.assemblyObj.reasonCode4 = this.assemblyObj.reasonObj[i].code;
      this.controlReason(type);
    }
    else if (type == 'reason5') {
      let i = this.assemblyObj.reasonObj.findIndex(item => item.id == id);
      this.assemblyObj.reasonCode5 = this.assemblyObj.reasonObj[i].code;
      this.controlReason(type);
    }

    else if (type == 'breason1') {
      let i = this.batchInspectionObj.reasonObj.findIndex(item => item.id == id);
      this.batchInspectionObj.reasonCode1 = this.batchInspectionObj.reasonObj[i].code;
      this.controlBReason(type);
    }
    else if (type == 'breason2') {
      let i = this.batchInspectionObj.reasonObj.findIndex(item => item.id == id);
      this.batchInspectionObj.reasonCode2 = this.batchInspectionObj.reasonObj[i].code;
      this.controlBReason(type);
    }
    else if (type == 'breason3') {
      let i = this.batchInspectionObj.reasonObj.findIndex(item => item.id == id);
      this.batchInspectionObj.reasonCode3 = this.batchInspectionObj.reasonObj[i].code;
      this.controlBReason(type);
    }
    else if (type == 'breason4') {
      let i = this.batchInspectionObj.reasonObj.findIndex(item => item.id == id);
      this.batchInspectionObj.reasonCode4 = this.batchInspectionObj.reasonObj[i].code;
      this.controlBReason(type);
    }
    else if (type == 'breason5') {
      let i = this.batchInspectionObj.reasonObj.findIndex(item => item.id == id);
      this.batchInspectionObj.reasonCode5 = this.batchInspectionObj.reasonObj[i].code;
      this.controlBReason(type);
    }

    else if (type == 'hose') {
      let i = this.speccodeObjClone.hoseObj.findIndex(item => item.id == id);
      this.speccodeObjClone.hoseCode = this.speccodeObjClone.hoseObj[i].code;
    }
    else if (type == 'bore') {
      let i = this.speccodeObjClone.boreObj.findIndex(item => item.id == id);
      this.speccodeObjClone.boreCode = this.speccodeObjClone.boreObj[i].code;
    }
    else if (type == 'endStyle1') {
      let i = this.speccodeObjClone.endObj.findIndex(item => item.id == id);
      this.speccodeObjClone.endStyleCode1 = this.speccodeObjClone.endObj[i].code;
    }
    else if (type == 'endStyle2') {
      let i = this.speccodeObjClone.endObj.findIndex(item => item.id == id);
      this.speccodeObjClone.endStyleCode2 = this.speccodeObjClone.endObj[i].code;
    }

    else if (type == 'thread1') {
      let i = this.speccodeObjClone.threadObj.findIndex(item => item.id == id);
      this.speccodeObjClone.threadSizeCode1 = this.speccodeObjClone.threadObj[i].code;
    }
    else if (type == 'thread2') {
      let i = this.speccodeObjClone.threadObj.findIndex(item => item.id == id);
      this.speccodeObjClone.threadSizeCode2 = this.speccodeObjClone.threadObj[i].code;
    }

    else if (type == 'insert1') {
      let i = this.speccodeObjClone.insertObj.findIndex(item => item.id == id);
      this.speccodeObjClone.insertTypeCode1 = this.speccodeObjClone.insertObj[i].code;
    }
    else if (type == 'insert2') {
      let i = this.speccodeObjClone.insertObj.findIndex(item => item.id == id);
      this.speccodeObjClone.insertTypeCode2 = this.speccodeObjClone.insertObj[i].code;
    }

    else if (type == 'retention1') {
      let i = this.speccodeObjClone.retentionObj.findIndex(item => item.id == id);
      this.speccodeObjClone.retentionTypeCode1 = this.speccodeObjClone.retentionObj[i].code;
    }
    else if (type == 'retention2') {
      let i = this.speccodeObjClone.retentionObj.findIndex(item => item.id == id);
      this.speccodeObjClone.retentionTypeCode2 = this.speccodeObjClone.retentionObj[i].code;
    }

  }

  getAssemblyDataByCode(code, type) {
    if (code) {
      this.reqRes.getData('/Assembly/GetAssemblyDataByCode/' + code + '/' + type).subscribe(data => {
        if (!data) { data = { id: 0, name: '' } };
        this.controlByCode(data, type);
      },
        error => {
          toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
          console.log(error);
        })
    }
    else {
     let  data = { id: 0, name: '' } ;
      this.controlByCode(data, type);
    }
  }
  formatToYYYYMMDD(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }
  changeDateByMonth(month, type) {
    if (month != 0) {
      if (type == 'inspFreq') {
        var _date = new Date(this.assemblyObj._date);
        const nextDate = new Date(_date.setMonth(_date.getMonth() + month));
        this.assemblyObj.nextInspectionDate = this.formatToYYYYMMDD(nextDate);
      }
      else if (type == 'replFreq') {
        if (this.assemblyObj.calcByInstallDateOpe) {
          var installDate = new Date(this.assemblyObj.installDate);
          const replDate = new Date(installDate.setMonth(installDate.getMonth() + month));
          this.assemblyObj.replDate = this.formatToYYYYMMDD(replDate);
        }
        else {
          var manuDate = new Date(this.assemblyObj.manuDate);
          const replDate = new Date(manuDate.setMonth(manuDate.getMonth() + month));
          this.assemblyObj.replDate = this.formatToYYYYMMDD(replDate);
        }
      }
    }
  }
  modalAssemblyClose() {
    let result = this.pluginservice.compareObjects(this.assemblyObj, this.assemblyObjTemp, ["id"])
    if (result) {
      if (confirm('Close without saving??')) {
        $('#assemblyModal').modal('hide');
      }
    }
    else {
      $('#assemblyModal').modal('hide');
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const result = bytes / Math.pow(1024, i);
    return result.toFixed(result < 10 ? 2 : 1) + ' ' + sizes[i];
  }

  saveFiles(id): Observable<any> {
    if (this.newFileObj.length == 0) return of({ status: "success", uploaded: 0 });

    const formData = new FormData();
    formData.append('assemblyId', id);

    this.newFileObj.forEach((x, index) => {
      formData.append('files', x._file);
      formData.append('descs', x._desc);
      formData.append('types', x._type);
    });
    return this.reqRes.postFormData('/Assembly/UploadFiles', formData);
  }

  saveAssembly(ope) {
    if (this.assemblyObj?.speccodeObj) {
      this.assemblyObj.speccodeObj =
        typeof this.assemblyObj.speccodeObj === 'string'
          ? JSON.parse(this.assemblyObj.speccodeObj)
          : this.assemblyObj.speccodeObj;
    }

    this.assemblyObj.methodId = parseInt(this.assemblyObj.methodId)
    this.assemblyObj.typeId = parseInt(this.assemblyObj.typeId)
    this.assemblyObj.boreSize = this.assemblyObj.boreSize.toString();





    //console.log(JSON.stringify(this.assemblyObj))
    this.reqRes.postData('/Assembly/SaveAssemblyDetail', this.assemblyObj).subscribe(data => {
      if (this.assemblyObj.id != 0) {
        let index = this.assemblyList.findIndex(item => item.id == data.id);
        if (index >= 0) {
          this.assemblyList.splice(index, 1);
        }
      }
      this.assemblyObj.id = data.id;
      this.assemblyList.unshift(data);
      this.saveFiles(data.id).subscribe(uploadResult => {
        this.newFileObj = [];
        toastr.success(uploadResult.uploaded > 0 ? 'Done! Files uploaded successfully.' : 'Done!', '', { timeOut: 1200 });
        if (ope == 1) {
          $('#assemblyModal').modal('hide');
        }
        else if (ope == 2) {
          this.next(data.id, 'NEXT');
        }
      },
        uploadError => {
          const uploadMessage = typeof uploadError.error === 'string' ? uploadError.error : "File upload failed.";
          toastr.error("Assembly saved, but " + uploadMessage + " Please try saving again before moving to another record.", '', { timeOut: 5000 });
          console.log(uploadError);
        });
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
  changeType() {
    let index = this.assemblyObj.typeList.findIndex(item => item.id == this.assemblyObj.type);
    this.assemblyObj.order = this.assemblyObj.type == '' ? 0 : this.assemblyObj.typeList[index]?.order;
    this.assemblyObj.statusTitle = this.assemblyObj.type == '' ? '' : this.assemblyObj.typeList[index]?.desc;
  }
  //#endregion Assembly
  //================================================================


  //================================================================
   //#region BatchInspection
  modalTitleBatchInspection: string = "Batch Inspection";
  batchInspectionObj: any = {};
  batchInspection() {
    this.reqRes.getData('/Assembly/BatchInspectionDetail').subscribe(data => {
      $('#batchInspectionModal').modal('show');
      this.batchInspectionObj = data;
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }

  saveBatchInspection() {
    let json = {
      "Search": '',
      "Count": this.assemblyCount,
      "Direction": 'D',
      "SortType": this.sortType
    };
    let _obj: any = {};
    _obj = this.batchInspectionObj;
    _obj.ids = this._pluginservice.checkedList;
    this.reqRes.postData('/Assembly/BatchInspectionOperation', _obj).subscribe(data => {
      this.getAssemblyList(JSON.stringify(json), 0);
      this.modalBatchInspectionClose();
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error)
    })
  }

  modalBatchInspectionClose() {
    $('#batchInspectionModal').modal('hide');
  }
   //#endregion BatchInspection
  //================================================================



  exportDataArray: any = [];

  getExportData(type) {

    let _obj: any = {};
    _obj.ids = this._pluginservice.checkedList;
    if (type == 'excell') {
      this.reqRes.postData('/Assembly/GetExportData', _obj).subscribe(data => {
        this.exportDataArray = data;
        this.exportToExcel("EXCELL_EXPORT_WELT.xlsx", this.exportDataArray);
      }, error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
    }
    else if (type == 'pdf') {
      this.http.post('/Assembly/ExportPdf', _obj, {
        responseType: 'blob',
        observe: 'response'
      })
        .subscribe(resp => {
          const blob = resp.body!;
          const cd = resp.headers.get('content-disposition') || '';
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = "WIMS_PDF_EXPORT.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        });
    }
  }



  exportToPDF(filename = 'export.pdf', data) {
    const element = document.getElementById("pdf-area");
    const opt = {
      margin: 0,
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
     jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
    };

    html2pdf().from(element).set(opt).save();
  }

  exportToExcel( filename = 'export.xlsx',data) {
      // Məsələn, JSON belədir:
    let jsonArray = data;
      const columns = [
        { key: "serialNo", label: "Serial No" },
        { key: "locTagNo", label: "Loc Tag No" },
        { key: "company", label: "Customer" },
        { key: "asset", label: "Asset" },
        { key: "condition", label: "Condition" },
        { key: "_class", label: "Class" },
        { key: "specCode", label: "Spec Code" },
        { key: "media", label: "Media" },
        { key: "service", label: "Service" },
        { key: "deck", label: "Deck" },
        { key: "module", label: "Module" },
        { key: "ep", label: "Eq Package" },
        { key: "location1", label: "Location 1" },
        { key: "location2", label: "Location 2" },
        { key: "custRef1", label: "Cust Ref 1" },
        { key: "custRef2", label: "Cust Ref 2" },
        { key: "catInt", label: "Catalogue Internal Reference" },
        { key: "catCust", label: "Catalogue Customer Reference" },
        { key: "refCode", label: "Survey Ref" },
        { key: "inspDate", label: "Insp.Date" },
        { key: "inspFreq", label: "Insp.Freq" },
        { key: "nextInspectionDate", label: "Next Insp." },
        { key: "replFreq", label: "Replacement Frequency" },
        { key: "replDate", label: "Replacement Date" },
        { key: "manuDate", label: "Manu Date" },
        { key: "inspector", label: "Insp.Name" },
        { key: "reason1", label: "Reason 1" },
        { key: "reason2", label: "Reason 2" },
        { key: "reason3", label: "Reason 3" },
        { key: "reason4", label: "Reason 4" },
        { key: "reason5", label: "Reason 5" },
        { key: "inspectionType", label: "Insp.Type" },
        { key: "supplier", label: "Supplier" },
        { key: "salesOrder", label: "Sales Order" },
        { key: "custPO", label: "Cust Po" },
        { key: "consequence", label: "Consequence" },
        { key: "probability", label: "Probability" },
        { key: "custAttribute", label: "Cust Attribute" },
        { key: "inspectionComment", label: "Inspection Comment" },
        { key: "recommendation", label: "Recommendation" },

      ];

      // Başlıqlar
      const headerRow = columns.map(c => c.label);

      // Məlumat sətirləri
      const dataRows = jsonArray.map(obj =>
        columns.map(c => obj[c.key] ?? "")
      );

      const allRows = [headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(allRows);

    const headerRange = XLSX.utils.decode_range(ws['!ref']);
    for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C }); // 0-cı sətr (başlıqlar)
      if (!ws[cellAddress]) continue;

      ws[cellAddress].s = {
        fill: { fgColor: { rgb: "ADD8E6" } }, // Açıq mavi fon
        font: { bold: true, color: { rgb: "000000" } },
        alignment: { horizontal: "center", vertical: "center" }
      };
    }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Assembly List");
    XLSX.writeFile(wb, filename);

  }
  //Speccode
  modalTitleSpeccode: string = "Assembly Specification Code Wizard";
  speccodeObj: any = {};
  speccodeObjClone: any = {};

  getSpeccodePopup() {
    if (this.assemblyObj?.speccodeObj) {
      this.speccodeObj =
        typeof this.assemblyObj.speccodeObj === 'string'
          ? JSON.parse(this.assemblyObj.speccodeObj)
          : this.assemblyObj.speccodeObj;
    } else {
      this.speccodeObj = [];
    }
    this.speccodeObjClone = JSON.parse(JSON.stringify(this.speccodeObj));
    $('#speccodeModal').modal('show');
    $('#assemblyModal').modal('hide');

    $('#speccodeModal').off('shown.bs.modal').on('shown.bs.modal', () => {
      this.initSpeccodeSelect2();
    });
  }

  modalSpeccodeClose() {
    $('#speccodeModal').modal('hide');
    $('#assemblyModal').modal('show');
  }

  saveSpeccode() {
    

    this.speccodeObjClone.hoseId = parseInt(this.speccodeObjClone.hoseId);
    this.speccodeObjClone.boreId = parseInt(this.speccodeObjClone.boreId);
    this.speccodeObjClone.endStyleId1 = parseInt(this.speccodeObjClone.endStyleId1);
    this.speccodeObjClone.threadSizeId1 = parseInt(this.speccodeObjClone.threadSizeId1);
    this.speccodeObjClone.insertTypeId1 = parseInt(this.speccodeObjClone.insertTypeId1);
    this.speccodeObjClone.retentionTypeId1 = parseInt(this.speccodeObjClone.retentionTypeId1);

    this.speccodeObjClone.endStyleId2 = parseInt(this.speccodeObjClone.endStyleId2);
    this.speccodeObjClone.threadSizeId2 = parseInt(this.speccodeObjClone.threadSizeId2);
    this.speccodeObjClone.insertTypeId2 = parseInt(this.speccodeObjClone.insertTypeId2);
    this.speccodeObjClone.retentionTypeId2 = parseInt(this.speccodeObjClone.retentionTypeId2);


    this.assemblyObj.specCode = this.speccodeObjClone.specCode;
    this.assemblyObj.specCodeDesc = this.speccodeObjClone.specCodeDesc;

    let index_bore = this.speccodeObjClone.hoseObj.findIndex(item => item.id == this.speccodeObjClone.hoseId);
    this.assemblyObj.boreSize = this.speccodeObjClone.boreObj[index_bore].name;

    this.assemblyObj.boreLength = this.speccodeObjClone._length;
    this.assemblyObj.orientation = this.speccodeObjClone._orientation;
    let index = this.speccodeObjClone.hoseObj.findIndex(item => item.id == this.speccodeObjClone.hoseId);
    this.assemblyObj.hoseType = this.speccodeObjClone.hoseObj[index].name;

    this.generateSpeccode();

    this.assemblyObj.speccodeObj = this.speccodeObjClone;
    this.modalSpeccodeClose();
  }
  generateSpeccode() {
    console.log(JSON.stringify(this.speccodeObjClone));
    this.reqRes.postData('/Assembly/GetSpeccodeByIds', this.speccodeObjClone).subscribe(data => {
      this.speccodeObjClone.specCode = data.specCode;
      this.speccodeObjClone.specCodeDesc = data.specCodeDesc;

    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error)
    })
  }

  changeSameEndsOpe(ope) {
    if (ope) {
      this.speccodeObjClone.endStyleCode2 = this.speccodeObjClone.endStyleCode1;
      this.speccodeObjClone.endStyleId2 = this.speccodeObjClone.endStyleId1;
      this.speccodeObjClone.threadSizeCode2 = this.speccodeObjClone.threadSizeCode1;
      this.speccodeObjClone.threadSizeId2 = this.speccodeObjClone.threadSizeId1;
      this.speccodeObjClone.insertTypeCode2 = this.speccodeObjClone.insertTypeCode1;
      this.speccodeObjClone.insertTypeId2 = this.speccodeObjClone.insertTypeId1;
      this.speccodeObjClone.retentionTypeCode2 = this.speccodeObjClone.retentionTypeCode1
      this.speccodeObjClone.retentionTypeId2 = this.speccodeObjClone.retentionTypeId1;
    }
    else {
      this.speccodeObjClone.endStyleCode2 = '';
      this.speccodeObjClone.endStyleId2 = 0;
      this.speccodeObjClone.threadSizeCode2 = '';
      this.speccodeObjClone.threadSizeId2 = 0;
      this.speccodeObjClone.insertTypeCode2 = '';
      this.speccodeObjClone.insertTypeId2 = 0;
      this.speccodeObjClone.retentionTypeCode2 = ''
      this.speccodeObjClone.retentionTypeId2 = 0;
    }
  }


  hoseCode: string = "";
  hoseName: string = "";
  newHose() {
    this.hoseCode = "";
    this.hoseName = "";
    $('#hoseModal').modal('show');
  }
  modalHoseClose() {
    $('#hoseModal').modal('hide');
  }
  saveHose() {
    let hoseObj: any = {};
    hoseObj.code = this.hoseCode;
    hoseObj.name = this.hoseName;
    this.reqRes.postData('/Assembly/NewHoseOperation', hoseObj).subscribe(data => {
      this.speccodeObjClone.hoseObj.push({ id: data, code: this.hoseCode, name: this.hoseName });


      if (this.assemblyObj?.speccodeObj) {
        this.assemblyObj.speccodeObj =
          typeof this.assemblyObj.speccodeObj === 'string'
            ? JSON.parse(this.assemblyObj.speccodeObj)
            : this.assemblyObj.speccodeObj;
      }


      this.assemblyObj.speccodeObj.hoseObj.push({ id: data, code: this.hoseCode, name: this.hoseName });
      $('#hoseModal').modal('hide');


    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error)
    })


   
  }




  initSpeccodeSelect2() {
    setTimeout(() => {
      const modal = $('#speccodeModal');

      modal.find('select.select2').each((index, el) => {
        const $select = $(el);

        if ($select.hasClass('select2-hidden-accessible')) {
          $select.select2('destroy');
        }

        $select.select2({
          width: '100%',
          dropdownParent: modal,
          placeholder: 'Choose'
        });

        $select.off('change.select2Angular').on('change.select2Angular', () => {
          const value = $select.val();
          const id = $select.attr('id');

          if (id === 'slc_scHose') {
            this.speccodeObjClone.hoseId = Number(value);
            this.codeById(this.speccodeObjClone.hoseId, 'hose');
          }

          if (id === 'slc_scBore') {
            this.speccodeObjClone.boreId = Number(value);
            this.codeById(this.speccodeObjClone.boreId, 'bore');
          }

          if (id === 'slc_scEndStyle1') {
            this.speccodeObjClone.endStyleId1 = Number(value);
            this.codeById(this.speccodeObjClone.endStyleId1, 'endStyle1');
          }

          if (id === 'slc_scThreadSize1') {
            this.speccodeObjClone.threadSizeId1 = Number(value);
            this.codeById(this.speccodeObjClone.threadSizeId1, 'thread1');
          }

          if (id === 'slc_scInsertType1') {
            this.speccodeObjClone.insertTypeId1 = Number(value);
            this.codeById(this.speccodeObjClone.insertTypeId1, 'insert1');
          }

          if (id === 'slc_scRetentionType1') {
            this.speccodeObjClone.retentionTypeId1 = Number(value);
            this.codeById(this.speccodeObjClone.retentionTypeId1, 'retention1');
          }

          if (id === 'slc_scEndStyle2') {
            this.speccodeObjClone.endStyleId2 = Number(value);
            this.codeById(this.speccodeObjClone.endStyleId2, 'endStyle2');
          }

          if (id === 'slc_scThreadSize2') {
            this.speccodeObjClone.threadSizeId2 = Number(value);
            this.codeById(this.speccodeObjClone.threadSizeId2, 'thread2');
          }

          if (id === 'slc_scInsertType2') {
            this.speccodeObjClone.insertTypeId2 = Number(value);
            this.codeById(this.speccodeObjClone.insertTypeId2, 'insert2');
          }

          if (id === 'slc_scRetentionType2') {
            this.speccodeObjClone.retentionTypeId2 = Number(value);
            this.codeById(this.speccodeObjClone.retentionTypeId2, 'retention2');
          }
        });
      });
    }, 300);
  }



}

